import React, { useEffect, useRef, useState } from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import SEO from "../../components/SEO";
import { color, motion, transform, useInView } from "framer-motion";
import Link from "../../components/v2/Link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import clsx from "clsx";

import compareItemImg1 from "../../images/v4/whatsappCatalogue/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg5 from "../../images/v4/salesReps/topcrm/freshsale.png";

import swiperIcon1 from "../../images/v4/aiSalesCrm/icons/swiperIcon1.svg";
import swiperIcon2 from "../../images/v4/aiSalesCrm/icons/swiperIcon2.svg";
import swiperIcon3 from "../../images/v4/aiSalesCrm/icons/swiperIcon3.svg";
import swiperIcon4 from "../../images/v4/aiSalesCrm/icons/swiperIcon4.svg";

import growingIcon1 from "../../images/v4/user-based-tools/eCommerce/icons/growingIcon1.svg";
import growingIcon2 from "../../images/v4/user-based-tools/eCommerce/icons/growingIcon2.svg";
import growingIcon3 from "../../images/v4/user-based-tools/eCommerce/icons/growingIcon3.svg";
import growingIcon4 from "../../images/v4/user-based-tools/eCommerce/icons/growingIcon4.svg";
import growingIcon5 from "../../images/v4/user-based-tools/eCommerce/icons/growingIcon5.svg";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/client7.png";

import benefitIcon1 from "../../images/v4/user-based-tools/eCommerce/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/user-based-tools/eCommerce/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/user-based-tools/eCommerce/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/user-based-tools/eCommerce/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/user-based-tools/eCommerce/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/user-based-tools/eCommerce/icons/benefitIcon6.svg";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import benefitSectionBg from "../../images/v4/user-based-tools/eCommerce/images/benefitSectionBg.png";
import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import flipSectionBg from "../../images/v4/user-based-tools/emailIntegration/images/flipSectionBg.png";
import heroSectionBg from "../../images/v4/user-based-tools/eCommerce/images/heroSectionBg.png";
import growingBussinessBg from "../../images/v4/user-based-tools/eCommerce/images/growingBussinessBg.png";
import heroSectionImg from "../../images/v4/user-based-tools/eCommerce/images/heroSectionImg.webp";
import swiperCardBg from "../../images/v4/user-based-tools/emailIntegration/images/swiperCardBg.png";
import combineSectionBg from "../../images/v4/user-based-tools/eCommerce/images/combineSectionBg.png";
import compareBg from "../../images/v4/user-based-tools/messagingCommunication/images/compareBg.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import ClientScroll from "../../components/v4/clientScroll/ClientScroll";

import broadcastImg1 from "../../images/v4/user-based-tools/eCommerce/images/broadcastImg1.webp";

import flipImg1 from "../../images/v4/user-based-tools/emailIntegration/images/flipImg1.webp";
import flipImg2 from "../../images/v4/user-based-tools/emailIntegration/images/flipImg2.webp";
import flipImg3 from "../../images/v4/user-based-tools/emailIntegration/images/flipImg3.webp";

import tabIcon1 from "../../images/v4/user-based-tools/emailIntegration/icons/tabIcon1.svg";
import tabIcon2 from "../../images/v4/user-based-tools/emailIntegration/icons/tabIcon2.svg";
import tabIcon3 from "../../images/v4/user-based-tools/emailIntegration/icons/tabIcon3.svg";

import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

const useStyles = makeStyles((theme) => ({
  whatsappSection: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "60px 0",
    backgroundImage: `url(${heroSectionBg})`,
    "& $aiSectionLeft": {
      width: "53%",
      gap: "25px",
    },
    "& .countryHighlight": {
      background: "linear-gradient(90deg, #25D366 0%, #0D4D85 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .buttonContaienr": {
      marginTop: "20px",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 600px)": {
      backgroundPosition: "bottom",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      "& $aiSectionLeft": {
        width: "100%",
        gap: "16px",
        "&  .wpLogo": {
          width: "40px",
          height: "40px",
          position: "relative",
          top: "10px",
        },
      },
      padding: "0px",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
      },
      "& .container": {
        paddingBottom: "40px",
      },
      "& .buttonContaienr": {
        marginTop: "10px",
      },
    },
  },
  aiSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "20px",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    // "&  .wpLogo": {
    //   width: "40px",
    //   height: "40px",
    //   position: "relative",
    //   top: "10px",
    // },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    width: "100%",
    flexWrap: "wrap",
    // flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      minWidth: "100%",
      gap: "8px",
      marginTop: "0",
    },
  },
  listItem: {
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid rgba(241, 223, 255, 0.40)",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {},
    // color: "#A2BED3",
  },
  flipSection: {
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${flipSectionBg})`,
    "& .centerContainer": {
      width: "80%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .stackWrapper": {
      height: "700px",
      marginTop: "80px",
      "@media only screen and (max-width: 600px)": {
        height: "950px",
        marginTop: "60px",
      },
    },
  },
  tabs: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "48px 0",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      overflow: "auto",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  flipTopHeader: {
    width: "80%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "0 auto",
    textAlign: "center",
  },
  tab: {
    cursor: "pointer",
    gap: "10px",
    width: "32%",
    display: "flex",
    justifyContent: "center",
    padding: "20px 20px",
    alignItems: "center",
    borderRadius: "60px",
    transition: "0.3s ease",
    border: "1px solid #C8D3E0",
    "&.active": {
      background: "#FF682A",
      border: "1px solid #FF682A",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "16px 20px",
    },
  },
  flipCard: {
    background: "#fff",
    borderRadius: "24px",
    overflow: "hidden",
    display: "flex",
    width: "100%",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  flipCardLeft: {
    width: "50%",
    paddingTop: "40px",
    display: "flex",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      paddingTop: "0px",
    },
  },
  flipCardRight: {
    padding: "40px",
    width: "50%",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "20px",
      gap: "20px",
    },
  },
  flipCardRightHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  flipCardPointers: {
    display: "flex",
    gap: "40px",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  flipCardPointer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "45%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  growingBusiness: {
    backgroundImage: `url(${growingBussinessBg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "80px",
    position: "relative",
    "& .header": {
      width: "80%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      gap: "32px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "50px",
      "& .header": {
        width: "100%",
      },
    },
  },
  broadcastContainerInner: {
    gap: "30px",
    width: "100%",
    display: "flex",
    padding: "0 16rem 0rem 16rem",
    paddingBottom: "10px !important",
    alignItems: "stretch",
    justifyContent: "flex-start",
    "& swiper-wrapper": {
      alignItems: "stretch !important",
    },

    "& $featureContainer": {
      width: "31%",
      height: "auto  !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px !important",
      paddingBottom: "10px !important",
    },
    // "@media only screen and (min-width: 1900px)": {
    //   paddingLeft: "40rem !important",
    //   paddingRight: "40rem !important",
    // },
  },
  featureContainer: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "32%",
    gap: "22px",
    boxShadow: "0px 0px 16px #C1D7DB66",
    borderRadius: "16px",
    background: "#fff",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
    "& p": {
      width: "90%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& p": {
        width: "100%",
      },
    },
  },
  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${combineSectionBg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    // backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "40px",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "0px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "100px 0",
      paddingTop: "0px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "100px 0",
      paddingTop: "0px",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    marginBottom: "90px",
    color: "#fff",
    "& h2": {
      margin: "16px 0 32px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& h2": {
        paddingRight: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
      padding: "0 15px",
      "& p": {
        textAlign: "center",
      },
      "& h2": {
        textAlign: "center",
        paddingRight: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& h2": {
        textAlign: "center",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  faqBoxAccordian: {
    padding: "0 16px",
    backgroundColor: "transparent",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "& h3": {
      color: "#0A2035",
      opacity: "0.7",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "2px",
      height: "100%",
      background: "rgba(0, 0, 0, 0.30)",
    },
    "&:before": {
      borderRadius: "0 0 4px 4px",
      content: '""',
      position: "absolute",
      background: "linear-gradient(180deg,#B1DBFF 0%, #fff 0%, #0089FF 100% )",
      left: "-1px",
      top: "0",
      width: "4px",
      height: "100%",
      transform: "scaleY(0)",
      transformOrigin: "top",
      zIndex: 1,
    },
    "&.active": {
      "& h3": {
        color: "#0A2035",
        opacity: "1",
      },
      "&:before": {
        animation: "growTimer 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  compareSection: {
    backgroundImage: `url(${compareBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "top",
    paddingTop: "280px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "160px",
    },
  },
  benefitSection2: {
    backgroundImage: `url(${benefitSectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      "& h2": {
        width: "100%",
      },
      "& p": {
        textAlign: "left",
        width: "40%",
      },
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        gap: "16px",
        "& h2": {
          width: "100%",
          textAlign: "left",
        },
        "& p": {
          textAlign: "left",
          width: "100%",
        },
      },
    },
  },
  broadcastContainer: {
    background: "#FFF7F1",
    // backgroundImage: `url(${broadcastBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      marginBottom: "40px",
      textAlign: "center",
    },
    "& $broadcastRightContainer": {
      width: "40%",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
      "& $broadcastRightContainer": {
        width: "100%",
      },
    },
  },
  benefitContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "stretch",
    gap: "24px",
    rowGap: "24px",
    margin: "60px 0 0",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  benefitBox: {
    display: "flex",
    border: "1px solid rgba(255, 255, 255, 0.10)",
    background: "rgba(255, 255, 255, 0.10)",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    width: "32%",
    padding: "24px",
    borderRadius: "16px",
    transition: "0.3s ease",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "12px",
      padding: "16px",
    },
    // "&:hover": {
    //   transition: "0.3s ease",
    //   background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
    //   "@media only screen and (max-width: 600px)": {
    //     "&:hover": {
    //       background: "transparent",
    //     },
    //   },
    // },
  },
  broadcastBox: {
    display: "flex !important",
    padding: "40px",
    background: "#009249",
    alignItems: "center",
    borderRadius: "20px",
    justifyContent: "space-between",
    transition: "0.3s ease",
    overflow: "hidden",
    "&.active": {
      transform: "scale(1) !important",
    },
    "&.inActive": {
      transform: "scale(0.8) !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px",
      gap: "15px",
      flexDirection: "column-reverse",
      minHeight: "750px",
      justifyContent: "space-between",
      //   minWidth: "90%",
      //   maxWidth: "90%",
    },
    "@media only screen and (min-width: 1800px)": {
      //   minWidth: "80%",
      //   maxWidth: "80%",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "55%",
    gap: "10px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  cardPointer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "flex-start",
    },
    "& .cardPointerIcon":{
      paddingTop:'3px'
    }
  },
}));

const ECommerce = () => {
  const classes = useStyles();
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const AUTO_PLAY_INTERVAL = 10000;
  const sectionRef = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });
  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];
    const logotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
        case 2:
          logotrack3.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
      logotrack3,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2, logotrack3 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo-2");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 25 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row-2").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Zoho CRM",
    "Salesforce CRM",
    "Freshsales CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud stands out as the best CRM for e-commerce integration—engineered specifically for online brands using platforms like Shopify. It combines deep automation, AI-driven insights, and seamless multi-platform sync to power smarter, faster, and more personalised e-commerce operations.",
      img: compareItemImg1,
      alt: "Pepper Cloud CRM",
      features: [
        {
          title: "Advanced marketing automation",
          desc: "Trigger personalised campaigns via email, SMS, and WhatsApp based on customer activity—such as browsing history, purchases, or cart abandonment.",
        },
        {
          title: "Full-spectrum order management",
          desc: "Manage everything from order tracking to fulfilment updates in one unified dashboard, reducing delays and human error.",
        },
        {
          title: "Inventory intelligence",
          desc: "Stay on top of stock levels with automated inventory sync, low-stock alerts, and warehouse visibility across channels.",
        },
        {
          title: "AI-powered lead intelligence",
          desc: "Analyse conversations and customer behaviours to identify high-potential leads, predict buying patterns, and guide your sales strategy.",
        },
        {
          title: "Mobile CRM for anytime access",
          desc: "Manage leads, deals, and customer communication on the go with a fully functional mobile CRM—ensuring business continuity even when your team is remote.",
        },
        {
          title: "Inbuilt tools and integrations",
          desc: "Leverage VOIP calling, AI chatbots, video conferencing, and UTM tracking—all within one centralised CRM platform.",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "A popular choice for its robust marketing and sales features. Ideal for businesses looking for a well-rounded CRM solution with smooth Shopify integration. HubSpot excels in lead nurturing, email marketing, and pipeline management, making it a solid choice for growing e-commerce brands.",
      img: compareItemImg3,
      alt: "HubSpot CRM",
      features: [
        {
          title: "Lead nurturing",
          desc: "Automate lead follow-ups and communication.",
        },
        {
          title: "Email marketing tools",
          desc: "Create and schedule personalised campaigns.",
        },
        {
          title: "Pipeline management",
          desc: "Visualise sales pipelines for better opportunity tracking.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Perfect for small to medium businesses seeking affordable CRM solutions for e-commerce business with Shopify. It offers customisable workflows, efficient inventory management, and robust sales automation. Zoho’s integration capabilities help streamline operations, track customer interactions, and enhance marketing efforts.",
      img: compareItemImg2,
      alt: "Zoho CRM",
      features: [
        {
          title: "Customisable workflows",
          desc: "Personalise business processes to match your needs.",
        },
        {
          title: "Inventory sync",
          desc: "Keep stock levels up-to-date in real-time.",
        },
        {
          title: "Sales automation",
          desc: "Automate repetitive tasks to boost productivity.",
        },
      ],
    },
    {
      title: "Salesforce CRM",
      desc: "A top choice for larger enterprises requiring highly customisable solutions. It supports complex sales processes and deep Shopify integration for enhanced scalability. Salesforce is known for its powerful analytics, custom app development, and enterprise-level support, making it a leader in the CRM space.",
      img: compareItemImg4,
      alt: "Salesforce CRM",
      features: [
        {
          title: "Custom app development",
          desc: "Build custom solutions tailored to your business.",
        },
        {
          title: "Advanced analytics",
          desc: "Get deep insights into business performance.",
        },
        {
          title: "Enterprise-level support",
          desc: "Access 24/7 support for uninterrupted operations.",
        },
      ],
    },
    {
      title: "Freshsales CRM",
      desc: "Great for startups and small businesses looking for a user-friendly interface and quick setup. Its Shopify integration enables easy customer and order management. Freshsales is particularly strong in contact management, email tracking, and sales automation, making it a practical choice for smaller e-commerce ventures.",
      img: compareItemImg5,
      alt: "Freshsales CRM",
      features: [
        {
          title: "Contact management",
          desc: "Organise leads and customers efficiently.",
        },
        {
          title: "Email tracking",
          desc: "Monitor interactions to follow up effectively.",
        },
        {
          title: "Sales automation",
          desc: "Streamline repetitive tasks for faster closures.",
        },
      ],
    },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const faqs = [
    {
      question: "What is CRM in e-commerce and how does it help?",
      answer: (
        <>
          CRM in e-commerce refers to a system that helps online businesses
          manage customer relationships by organizing data from sales,
          marketing, support, and order interactions. When integrated with
          platforms like Shopify, it enables businesses to streamline workflows,
          reduce manual tasks, track customer behavior, and deliver a more
          personalized shopping experience.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM compatible with Shopify?",
      answer: (
        <>
          Yes, Pepper Cloud CRM offers seamless integration with Shopify. It
          allows real-time data synchronisation for inventory, orders, and
          customer information across platforms—ensuring accurate and timely
          fulfilment.
        </>
      ),
    },
    {
      question: "How does Pepper Cloud help with inventory management?",
      answer: (
        <>
          Pepper Cloud CRM synchronises your inventory data in real time with
          Shopify. You can set low-stock alerts, prevent overselling, and manage
          multiple warehouses with ease, helping you run a lean, efficient
          operation.
        </>
      ),
    },
    {
      question: "Does Pepper Cloud support mobile CRM functionality?",
      answer: (
        <>
          Yes, Pepper Cloud offers a fully functional mobile CRM that lets your
          team manage leads, view reports, and communicate with customers on the
          go—ideal for remote teams and real-time decision-making.
        </>
      ),
    },
    {
      question: "What kind of insights does the CRM provide?",
      answer: (
        <>
          The AI-powered analytics engine offers insights into sales
          performance, campaign effectiveness, customer behaviour, and lead
          quality—helping e-commerce teams make smarter, data-driven decisions.
        </>
      ),
    },
    {
      question: "Can I use Pepper Cloud CRM for customer support?",
      answer: (
        <>
          Yes. The CRM integrates with WhatsApp, email, live chat, and other
          communication platforms—making it easier to manage and respond to
          customer queries from one place.
        </>
      ),
    },
    {
      question: "Is it suitable for small e-commerce businesses too?",
      answer: (
        <>
          Definitely. Pepper Cloud CRM is scalable and user-friendly, making it
          perfect for startups, D2C brands, and fast-growing online businesses
          that want to automate without complexity.
        </>
      ),
    },
  ];

  const swiperCards = [
    {
      icon: swiperIcon1,
      heading: "Auto call recording",
      contentOne:
        "Save time by auto-recording AirCall and KrispCall calls, documenting conversations seamlessly.",
    },
    {
      icon: swiperIcon2,
      heading: "CRM‑linked meeting",
      contentOne:
        "Schedule Zoom meetings within your CRM—meeting links auto-attach to contacts and deals for seamless tracking.",
    },
    {
      icon: swiperIcon3,
      heading: "Intelligent call routing",
      contentOne:
        "Connect call data with CRM contacts instantly, reducing manual updates and keeping records complete.",
    },
    {
      icon: swiperIcon4,
      heading: "Rich analytics dashboard",
      contentOne:
        "Monitor calls and meetings in CRM dashboards to guide smarter, data-driven decisions.",
    },
  ];

  const growingList = [
    {
      icon: growingIcon1,
      background: "linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      heading: "AI-powered insights",
      text: "Track trends, sentiment, and buyer intent to personalise follow-ups and boost conversions.",
    },
    {
      icon: growingIcon2,
      background: "linear-gradient(180deg, #783CA8 0%, #31114B 100%)",
      heading: "Real-time sync",
      text: "Instantly update products, inventory, orders, and customer data to avoid stock issues and delays.",
    },
    {
      icon: growingIcon3,
      background: "linear-gradient(180deg, #014957 0%, #028BA6 100%)",
      heading: "Custom workflows",
      text: "Automate tasks like order processing and customer segmentation to save time and focus on growth.",
    },
    {
      icon: growingIcon4,
      background: "linear-gradient(180deg, #09939A 0%, #783CA8 100%)",
      heading: "E-commerce support",
      text: "Get 24/7 expert assistance, from onboarding to troubleshooting, tailored for online businesses.",
    },
    {
      icon: growingIcon5,
      background: "linear-gradient(180deg, #31114B 0%, #783CA8 100%)",
      heading: "Unified multichannel communication",
      text: "Manage chats from Shopify, WhatsApp, email, and more—on one platform so you never miss a customer.",
    },
  ];
  const clientScrollData = {
    title: "Trusted by top brands across industries",
    backgroundImage: "",
    logos: [
      {
        img: clientLogo1,
      },
      {
        img: clientLogo2,
      },
      {
        img: clientLogo3,
      },
      {
        img: clientLogo4,
      },
      {
        img: clientLogo5,
      },
      {
        img: clientLogo6,
      },
      {
        img: clientLogo7,
      },
    ],
    directions: ["left", "right", "left"],
    speeds: [0.8, 0.4, 0.8],
  };
  const benefits = [
    {
      title: "Customer insights",
      desc: "Get a complete view of each buyer's journey with real-time analytics to personalise marketing and boost repeat sales.",
      icon: benefitIcon1,
    },
    {
      title: "Marketing automation",
      desc: "Use e-commerce automation tools to launch targeted email, SMS, and social media campaigns that resonate.",
      icon: benefitIcon2,
    },
    {
      title: "Order management",
      desc: "Reduce manual work by syncing products, tracking payments, and managing fulfilments from one dashboard.",
      icon: benefitIcon3,
    },
    {
      title: "Sales forecasting",
      desc: "Access predictive insights with AI-powered reports to support accurate planning.",
      icon: benefitIcon4,
    },
    {
      title: "Omnichannel communication",
      desc: "Engage customers via WhatsApp, chat, email, and social media—all from one CRM system.",
      icon: benefitIcon5,
    },
    {
      title: "Faster lead capture",
      desc: "Automatically capture leads from your online store and convert them with timely, personalised follow-ups.",
      icon: benefitIcon6,
    },
  ];
  const broadcastList = [
    {
      heading: "Shopify CRM integration",
      content:
        "Streamline your store with Shopify e-commerce CRM integration. Capture leads, track activity, and manage marketing and fulfilment in real time with powerful e-commerce automation tools.",
      img: broadcastImg1,
      alt: "Online shop CRM integration tools",
      link: "/crm-integrations/shopify-ecommerce-integration/",
      background: "linear-gradient(180deg, #053333 0%, #009A99 100%)",
      points: [
        "Real-time sync of customer data, orders, and inventory from Shopify to CRM",
        "Launch personalised email, WhatsApp & SMS campaigns based on shopper behaviour.",
        "Automate order fulfilment and send status updates directly from your CRM.",
      ],
    },
  ];
  return (
    <main>
      <SEO
        title={
          "Best CRM for E-commerce Integration with Shopify | Pepper Cloud CRM"
        }
        pathname={
          "https://peppercloud.com/user-based-tools/crm-for-e-commerce-integration/"
        }
        keywords="e-commerce CRM integration, E-commerce CRM, e-commerce automation tools, What is CRM in e-commerce"
        description={
          "Streamline your online store with Pepper Cloud’s e-commerce CRM integration. Automate workflows, sync inventory in real time, and manage leads, campaigns & fulfilment in one smart dashboard."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        scripts={[`gtag('event', 'whatsapp_support_crm_generate_lead', {});`]}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What are the benefits of WhatsApp CRM for customer service?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "WhatsApp CRM improves response speed, ensures no query goes unanswered, enables team collaboration, and provides complete visibility into customer interactions. It also helps SMEs scale customer service without increasing staff costs.",
                },
              },
              {
                "@type": "Question",
                name: "What are the top 3 features which make our CRM ideal for customer support on WhatsApp?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Our CRM offers a smart ticketing system with automation rules, a multi-channel inbox with complete customer history, and real-time agent availability and assignment, making it ideal for customer support on WhatsApp.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best WhatsApp CRM for customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The best WhatsApp CRM should integrate seamlessly with your existing systems, offer automation to handle large volumes, provide detailed analytics, and be easy to use for your support team. For SMEs, it should also be scalable and cost-effective.",
                },
              },
              {
                "@type": "Question",
                name: "Can WhatsApp CRM work for small and medium businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. WhatsApp CRM is designed to scale with your business. SMEs benefit from automation, ticket management, and customer history features without needing large support teams.",
                },
              },
              {
                "@type": "Question",
                name: "How secure is customer data in a WhatsApp CRM system?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Most WhatsApp CRM systems follow strict compliance with WhatsApp Business API policies and data protection standards. This ensures conversations and customer data remain secure and private.",
                },
              },
              {
                "@type": "Question",
                name: "Does WhatsApp CRM integrate with other business tools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. A good WhatsApp CRM integrates with sales CRM, payment gateways, project management tools, and marketing platforms, helping you unify operations across teams.",
                },
              },
              {
                "@type": "Question",
                name: "How does WhatsApp CRM improve customer retention?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "By responding faster, personalising interactions, and keeping track of every customer’s history, WhatsApp CRM helps businesses build stronger relationships, increasing loyalty and repeat business.",
                },
              },
              {
                "@type": "Question",
                name: "What role does AI play in WhatsApp CRM for customer support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI enhances support by powering chatbots, automating repetitive queries, analysing sentiment, and assisting agents with quick, accurate responses—improving both efficiency and customer experience.",
                },
              },
              {
                "@type": "Question",
                name: "Can multiple team members manage the same customer conversation?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. With collaboration tools inside WhatsApp CRM, multiple agents can view, comment, and resolve queries together without losing context or duplicating work.",
                },
              },
              {
                "@type": "Question",
                name: "How does WhatsApp CRM support omnichannel communication?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A WhatsApp CRM combines WhatsApp, email, and other messaging platforms into one inbox, allowing teams to respond consistently across all channels.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.whatsappSection}>
        <div className="container">
          <div className={classes.aiSectionContainer}>
            <div className={classes.aiSectionLeft}>
              <motion.h1
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-64 font-white"
              >
                Boost sales with e-commerce CRM integration
              </motion.h1>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 font-white"
              >
                Integrate Shopify with powerful e-commerce CRM integration.
                Automate sales, manage stock, and grow faster.
              </motion.p>
              <div className={classes.listContainer}>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white  font-18">
                    Simplified operations
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Real-time inventory sync
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"WhatsApp CRM for customer service"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Automated marketing workflows
                  </p>
                </motion.div>
              </div>
              <div className="buttonContaienr">
                <Link
                  className="primaryButton font-16 font-wix-medium font-white"
                  to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <div className={classes.aiSectionRight}>
              <LazyImage
                source={heroSectionImg}
                width="100%"
                alt="E-commerce CRM integration for stores"
              />
            </div>
          </div>
        </div>
      </section>
      <ClientScroll
        {...clientScrollData}
        // background={topIndustiesBg}
        darkLayout={false}
      />
      <section className={classes.broadcastContainer}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black"
            >
              Simplify with Shopify e-commerce integration
            </motion.h2>
          </div>
          {broadcastList.map((point) => (
            <div
              className={classes.broadcastBox}
              style={{ background: point.background }}
            >
              <div className={classes.broadcastLeftContainer}>
                <p className="font-40 font-wix-medium font-white">
                  {point.heading}
                </p>
                <p className="font-18 font-wix-regular font-white mt10 mb20">
                  {point.content}
                </p>
                {point.points.map((content) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      alt={"pointer"}
                      className="cardPointerIcon"
                    />
                    <p className="font-wix-regular font-18 font-white">
                      {content}
                    </p>
                  </div>
                ))}
                <a
                  className="loginButton font-wix-medium font-16 mt20"
                  href={point.link}
                >
                  Know more
                </a>
              </div>
              <div className={classes.broadcastRightContainer}>
                <img
                  src={point.img}
                  alt={point.alt}
                  className={classes.broadcastImg}
                />
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className={classes.benefitSection2}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Benefits of using CRM with e-commerce integration
            </motion.h2>
            {/* <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-18 font-white"
            >
              Go beyond basic tools with an intelligent CRM designed to
              accelerate online business growth and streamline e-commerce
              operations.
            </motion.p> */}
          </div>
          <div className={classes.benefitContainer}>
            {benefits.map((benefit) => (
              <div className={classes.benefitBox}>
                <img src={benefit.icon} alt="Omnichannel CRM" />
                <p className="font-wix-semibold font-24 font-white">
                  {benefit.title}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Why Pepper Cloud is the best CRM for e-commerce integration?
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 color-black1"
            >
              Go beyond basic tools with an intelligent CRM designed to
              accelerate online business growth and streamline e-commerce
              operations.
            </motion.p>
          </div>
        </div>
        <Swiper
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={false}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          // freeMode={true}
          className={classes.broadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1.3,
              slidesPerGroup: 1,
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 3.3,
              centeredSlides: false,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {growingList.map((feature) => (
            <SwiperSlide
              className={classes.featureContainer}
              style={{ background: feature.background }}
            >
              <LazyImage
                source={feature.icon}
                alt={"WhatsApp CRM for customer service"}
                className={classes.featureIcon}
                // alt={listItem.alt}
              />
              <p className="font-wix-semibold font-24 font-white">
                {feature.heading}
              </p>
              <p className="font-wix-mediu font-18 font-white">
                {feature.text}
              </p>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div> */}
      </section>
      <section className={classes.combineSection}>
        <div className={classes.bussinessSuccesSection}>
          <div className={classes.bussinessSuccessContainer}>
            <div className={classes.integrationHeaderItem}>
              <div className={classes.integrationContent}>
                <motion.p
                  className="font-wix-semibold font-20 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Features
                </motion.p>
                <motion.h2
                  className="font-wix-semibold font-56 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Tailored for business success
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  The best CRM for sales reps who want to streamline their sales
                  process, stay organised, and win more deals.
                </motion.p>
              </div>
            </div>

            <section className="sales-logo-carousel">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row-2"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div
                          className="logo-2 logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row-2"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {logotrack2.map((logo) => (
                        <div className="logo-2 logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row-2"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack3.map((logo) => (
                        <div className="logo-2 logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    className="logos-row-2"
                    data-direction="right"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div className="logo-2 logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              5 Best CRM software with e-commerce integration
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` &&
                        "font-wix-semibold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={
            "Frequently asked questions about e-commerce CRM integration "
          }
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Transform your online business with intelligent e-commerce CRM
              integration
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=CRM+email+integration&utm_medium=Show+me+how"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ECommerce;
